import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import {FiShield, FiUsers, FiTruck} from "react-icons/fi";

const AdvantagesSection = styled.section`
    background: linear-gradient(135deg, #f9f9f9, #f3efe8);
    padding: 80px 20px;
    text-align: center;
    position: relative;
`;

const AdvantagesTitle = styled(motion.h2)`
    font-size: clamp(1.8rem, 3vw, 2.4rem);
    color: #3d6c4d;
    margin-bottom: 60px;
`;

const AdvantagesWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 80px;
    flex-wrap: wrap;
    position: relative;

    &:before {
        content: "";
        position: absolute;
        top: 55px;
        left: 50%;
        transform: translateX(-50%);
        width: 60%;
        height: 4px;
        background: #c58e50;
        z-index: 0;
    }

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: center;

        &:before {
            display: none;
        }
    }
`;

const AdvantageItem = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 260px;
    position: relative;
    z-index: 1;
`;

const AdvantageCircle = styled.div`
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background: #3d6c4d;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 2rem;
    margin-bottom: 18px;
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.1);
        background: #2e5439;
    }
`;

const AdvantageTitle = styled.h3`
    font-size: 1.3rem;
    color: #c58e50;
    margin-bottom: 12px;
`;

const AdvantageText = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    color: #444;
`;

const fadeInUp = {
    hidden: {opacity: 0, y: 30},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6}},
};

export default function HomePage() {

    return (
        <AdvantagesSection id="advantages">
            <AdvantagesTitle
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true}}
            >
                Нашите предимства
            </AdvantagesTitle>
            <AdvantagesWrapper>
                <AdvantageItem
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <AdvantageCircle><FiShield/></AdvantageCircle>
                    <AdvantageTitle>Качество</AdvantageTitle>
                    <AdvantageText>
                        Сертифицирани материали, дълготрайна защита и пълна съвместимост на системата.
                    </AdvantageText>
                </AdvantageItem>

                <AdvantageItem
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <AdvantageCircle><FiUsers/></AdvantageCircle>
                    <AdvantageTitle>Подкрепа</AdvantageTitle>
                    <AdvantageText>
                        Обучения, консултации и асистенция при монтаж и стартиране на обекта.
                    </AdvantageText>
                </AdvantageItem>

                <AdvantageItem
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{once: true}}
                >
                    <AdvantageCircle><FiTruck/></AdvantageCircle>
                    <AdvantageTitle>Логистика</AdvantageTitle>
                    <AdvantageText>
                        Бързи доставки, гъвкави решения и пълна техническа подкрепа на терен.
                    </AdvantageText>
                </AdvantageItem>
            </AdvantagesWrapper>
        </AdvantagesSection>
    );
}
